import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';

export const DESKTOP_SIZE = 1200;

export const formatDate = (date: Date) => {
  return `${date.getDate() < 10 ? `${0}${date.getDate()}` : date.getDate()}/${date.getMonth() < 9 ? `${0}${date.getMonth() + 1}` : date.getMonth() + 1}/${date.getFullYear()}`;
};

export const getCurrentYear = () => {
  const currentDate = new Date();
  return currentDate.getFullYear();
};

export function isDesktopView(): boolean {
  const deviceSize = window.screen.width;
  return Boolean(deviceSize >= DESKTOP_SIZE);
}

export const hasDefinitiveLocation = (location?: string) => {
  if (!location) return false;
  return location?.split(',').length === 1;
};

const getWordForm = (value: number, forms: [string, string, string]) => {
  if (value === 0) return '';
  if (value === 1) return forms[0];
  if (value >= 2 && value <= 4) return forms[1];
  return forms[2];
};

export const formatDays = (days: number) =>
  getWordForm(days, ['dan', 'dana', 'dana']);
export const formatHours = (hours: number) =>
  getWordForm(hours, ['sat', 'sata', 'sati']);
export const formatMinutes = (minutes: number) =>
  getWordForm(minutes, ['minut', 'minuta', 'minuta']);

export function openGoogleMapsWithCoords(
  lat: number,
  lng: number,
  newTab: boolean = true
): void {
  const target = newTab ? '_blank' : '_self';
  window.open(
    `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
    target
  );
}

export function addAttemptedViewToLocalStorage() {
  let attemptedView = location.pathname + location.search;

  const featureRoots = ['feature1', 'feature2', 'feature3'];
  const excludedLocations = ['greska-prilikom-autorizacije'];

  featureRoots.forEach((root: string) => {
    attemptedView = attemptedView.replace(root, '');
  });

  excludedLocations.forEach((location: string) => {
    attemptedView = attemptedView.replace(location, '');
  });

  attemptedView = attemptedView.replace(/\/+/g, '/');

  localStorage.setItem(LOCAL_STORAGE_KEYS.ATTEMPTED_VIEW, attemptedView);
}

export function isInBlackFridayWeek(): boolean {
  const year = new Date().getFullYear();
  const thanksgiving = new Date(year, 10, 1);
  let thursdayCount = 0;

  while (thursdayCount < 4) {
    if (thanksgiving.getDay() === 4) {
      thursdayCount++;
      if (thursdayCount === 4) break;
    }
    thanksgiving.setDate(thanksgiving.getDate() + 1);
  }

  const blackFriday = new Date(thanksgiving);
  blackFriday.setDate(blackFriday.getDate() + 1);

  const daysFromMonday = (blackFriday.getDay() + 6) % 7;
  const monday = new Date(blackFriday);
  monday.setDate(monday.getDate() - daysFromMonday);

  const sunday = new Date(monday);
  sunday.setDate(sunday.getDate() + 6);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  monday.setHours(0, 0, 0, 0);
  sunday.setHours(23, 59, 59, 999);

  return today >= monday && today <= sunday;
}

export const formatQuizTime = (totalMs: number | string): string => {
  const seconds = Math.floor(+totalMs / 1000);
  const ms = +totalMs % 1000;
  return `${seconds}s : ${ms}ms`;
};
